module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Thin-794f1b6992ff5fe4f8a48a9ec41a8538.woff";